import {Pages} from "../components/layout";
import { useTitle } from "fearless-common-ui";
import Description from "../components/Description";
export default function NotFound() {
    useTitle('404 not found')
    return (
        <Pages.Centred padded width="xs">
            <h1 className="gradient-color">Page not found.</h1>
            <Description>
                Error 404: this page does not exist.
            </Description>
        </Pages.Centred>
    )
}
